import { supabase } from './supabase';

export interface AppSetting {
  key: string;
  value: any;
  label: string | null;
  description: string | null;
  category: string;
  updated_at: string;
}

let settingsCache: Map<string, any> | null = null;
let cacheTime = 0;
const CACHE_TTL = 60_000;

export async function fetchAppSettings(): Promise<Map<string, any>> {
  if (settingsCache && Date.now() - cacheTime < CACHE_TTL) return settingsCache;
  const { data } = await supabase.from('app_settings').select('*');
  const map = new Map<string, any>();
  if (data) for (const row of data) map.set(row.key, row.value);
  settingsCache = map;
  cacheTime = Date.now();
  return map;
}

export async function fetchAllAppSettings(): Promise<AppSetting[]> {
  const { data } = await supabase.from('app_settings').select('*').order('category').order('key');
  return (data || []) as AppSetting[];
}

export async function isFeatureEnabled(key: string): Promise<boolean> {
  const settings = await fetchAppSettings();
  return settings.get(key) === true;
}

export async function updateAppSetting(key: string, value: any): Promise<void> {
  const { error } = await supabase
    .from('app_settings')
    .update({ value, updated_at: new Date().toISOString() })
    .eq('key', key);
  if (error) throw error;
  settingsCache = null;
}

export function invalidateSettingsCache() { settingsCache = null; }
